import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DefaultFiltersState } from '@/stores'

import { SetFilterValue } from '../shared.ts'

export interface TemplateTableState extends DefaultFiltersState {}

const initialState: TemplateTableState = {
  page: 0,
  showCount: 10,
}

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<TemplateTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof TemplateTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const { reducer: templatesReducer, selectors: templatesSelectors, actions: templatesActions } = templatesSlice
